import React from "react";
import Paycolife from "../Components/Panel/Paycolife";
import PanelNav from "../Components/Panel/PanelNav";
import Layout from "./Layout";

export default function PaycolifePage() {
  return (
    <Layout>
      <section className="h-auto mx-auto max-w-screen-xl px-4 grid grid-cols-1 lg:grid-cols-6 xl:grid-cols-5 w-full my-6">
        <PanelNav />
        <Paycolife />
      </section>
    </Layout>
  );
}
